import React, { useState, useMemo } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useMousePosition } from "hooks";
import { Portal } from "components/atoms";
import { lighten } from "polished";

const Link = styled.a`
  color: #000;
  font-size: ${props => props.theme.sizes.s};
  &:hover {
    text-decoration-color: inherit;
  }
`;

const HelperStyled = styled.div`
  background-color: ${props => lighten(0.34, props.activeColor)};
  position: absolute;
  z-index: 9999;
  font-size: ${props => props.theme.sizes.xs};
  top: ${props => props.mouseY}px;
  left: ${props => props.mouseX}px;
  transform: translateY(-110%);
  padding: ${props => props.theme.spacing.xs3};
  font-weight: ${props => props.theme.weight.light};
`;

const Helper = ({ children, activeColor }) => {
  const { x: mouseX, y: mouseY } = useMousePosition();
  return (
    <HelperStyled
      style={{ top: mouseY, left: mouseX }}
      activeColor={activeColor}
    >
      {children}
    </HelperStyled>
  );
};

Helper.propTypes = {
  children: PropTypes.node.isRequired,
  activeColor: PropTypes.string
};

const LinkExternal = ({ href, children, activeColor, hasPop }) => {
  const [isHover, setHover] = useState(false);
  const cleanUrl = useMemo(
    () => href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, ""),
    [href]
  );

  return (
    <Link
      href={href}
      target="_blank"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="link-external"
      rel="noopener"
      native
    >
      {children}
      {hasPop && isHover && (
        <Portal>
          <Helper activeColor={activeColor}>{cleanUrl}</Helper>
        </Portal>
      )}
    </Link>
  );
};

LinkExternal.defaultProps = {
  href: "#",
  hasPop: true
};

LinkExternal.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  activeColor: PropTypes.string
};

export default LinkExternal;
